<template>
	<link-dialog
		v-model="p_show"
		v-bind="dialogProps"
		dialogClass="link-table-form-dialog"
		@confirm="p_confirm"
		@cancel="p_cancel">
		<pl-table-cell-controller ref="controller" tag="div" default-editing @itemsChange="p_itemsChange" :editable="editable" :required="required">
			<link-form>
				<link-form-column :labelWidth="labelWidth">
					<template v-for="(col,colIndex) in columns">
						<link-form-item :key="colIndex" :label="col.title" v-show="p_isShow(col)">
							<lv-scope-slot :scope-slot-func="col.colScopedSlot" :data="{row,editRow,rowIndex:0,col,colIndex}"/>
						</link-form-item>
					</template>
				</link-form-column>
			</link-form>
		</pl-table-cell-controller>
	</link-dialog>
</template>

<script>
	import LvScopeSlot from "../render/lv-scope-slot";
	import PlTableCellController from "./pl-table-cell-controller";

	export default {
		name: "link-table-form-dialog",
		components: {PlTableCellController, LvScopeSlot},
		props: {
			columns: {type: Array, default: () => []},
		},
		data() {
			const defaultDialogProps = {
				width: '500px',
				maxHeight: '500px',
				title: '编辑',
				confirmButton: true,
				cancelButton: true,
				disabledHideOnConfirm: true,
			}
			const defaultOption = {
				labelWidth: '100px',
				row: {},
				editRow: {},
				rowIndex: {},
				onConfirm: null,
				onCancel: null,
				editable: null,
				required: null,
				dialogProps: defaultDialogProps,
			}
			return {
				defaultOption,
				defaultDialogProps,

				...defaultOption,

				p_show: false,
				items: [],
			}
		},
		methods: {
			/**
			 * 打开表单对话框
			 *
			 * @author  韦胜健
			 * @date    2019/11/15 9:45
			 *
			 * @param   option.row                 编辑行原数据
			 * @param   option.editRow             编辑行编辑数据
			 * @param   option.rowIndex            行索引
			 * @param   option.onConfirm           点击确定时触发动作
			 * @param   option.onCancel            点击取消时触发动作
			 * @param   option.labelWidth          表单文本宽度
			 * @param   option.editable            为true|false表示强制设置表单中的元素的编辑状态，为null则表示不控制
			 * @param   option.required            为true|false表示强制设置表单中的元素的必输状态，为null则表示不控制
			 * @param   option.dialogProps         对话框props参数
			 *
			 * @param   columns             列数组数据
			 *
			 */
			show(option, columns) {
				let {row, editRow} = option
				row = this.$lv.$utils.deepCopy(row)
				editRow = this.$lv.$utils.deepCopy(editRow)
				option.dialogProps = Object.assign({}, this.defaultDialogProps, option.dialogProps)
				Object.assign(this, this.$lv.$utils.deepCopy(this.defaultOption), option, {row, editRow})

				this.columns = [...columns]
				this.p_show = true
			},
			close() {
				this.p_show = false
			},
			p_confirm() {
				const {flag, validateMsg, col} = this.$refs.controller.validate()
				if (flag) {
					!!this.onConfirm && this.onConfirm(this.editRow)
				} else {
					this.$dialog.show(`${col.title}${validateMsg}`)
				}
			},
			p_cancel() {
				this.p_show = false
				!!this.onCancel && this.onCancel()
			},
			p_itemsChange(items) {
				this.items = items
			},
			p_isShow(col) {
				const item = this.$lv.$utils.findOne(this.items, i => i.col === col)
				if (!item) return false
				return item.lv_editable && !col.disabledFormEdit
			},
		}
	}
</script>

<style lang="scss">
	.link-table-form-dialog {
		.link-form {
			width: 100%;

			.link-form-item, .lv-scope-slot, .pl-column-edit-item, .pl-popover, .pl-popover-reference {
				width: 100%;
			}

			.link-form-content {
				padding: 0 20px;
				width: 100%;
				box-sizing: border-box;

				.link-form-column {
					width: 100%;
				}
			}

			.link-form-item-content {
				width: initial;
				flex: 1;
				overflow: visible;
			}

			.pl-column-edit-item {
				& > div:not(.link-input-number) {
					width: 100% !important;
				}
			}

			.link-input:not(.link-input-number) {
				width: 100% !important;
			}

			.link-form-item:last-child {
				margin-bottom: 0;
			}

			.lv-column-text {
				justify-content: flex-start !important;
			}
		}
	}
</style>
